import { message } from "antd";
import { api, apiRequest } from "./api";
import { destroyCookie } from "nookies";

export async function login(authLogin: AuthLoginDto) {
  return apiRequest<VerifyAuthDto>("post", `/auth/login`, authLogin);
}

export async function loginAs(companyUuid: string) {
  return apiRequest<LoginAsDto>(
    "post",
    `/auth/forLoginAs?companyUuid=${companyUuid}`
  );
}

export async function loginTemporary() {
  return apiRequest<AccessTokenDto>("post", `/auth/login-temporary`);
}

export async function loginReportCode(reportCodeDto: CreateLoginReportDto) {
  return apiRequest<AccessTokenDto>(
    "post",
    `/auth/login-report`,
    reportCodeDto
  );
}

export async function register(createUser: CreateUsersDto) {
  return apiRequest<VerifyAuthDto>("post", `/auth/register`, createUser);
}

export async function registerByCompanyUuid(
  companyUuid: string,
  createUser: CreateUsersDto
): Promise<VerifyAuthDto> {
  let query = "?";
  query += companyUuid ? `companyUuid=${companyUuid}` : "";

  return await apiRequest<VerifyAuthDto>(
    "post",
    `/auth/register/company${query}`,
    createUser
  );
}

export async function forgotPassword(
  authForgotPassword: AuthForgotPasswordDto
) {
  return apiRequest<SucessAuthDto>(
    "post",
    `/auth/forgot-password`,
    authForgotPassword
  );
}

export async function resetPassword(authResetPassword: AuthResetPasswordDto) {
  return apiRequest<SucessAuthDto>(
    "post",
    `/auth/reset-password`,
    authResetPassword
  );
}

export async function verifyToken(): Promise<ReadUsersDto | undefined> {
  try {
    const response = await api.get("/auth/verify-token", {});

    if (response && response.data) {
      return response.data as ReadUsersDto;
    } else {
      throw new Error("Error on verify token");
    }
  } catch (error: any) {
    // if (
    //   error &&
    //   error.response &&
    //   error.response.data &&
    //   error.response.data.message
    // ) {
    //   message.error(error.response.data.message);
    // } else {
    //   message.error("Error on verify token");
    // }
    destroyCookie(undefined, "auth.token", {
      path: "/",
    });
  }
}

export async function generateTwoFactorAuthentication(
  generateTwoFactorAuthenticationDto: GenerateTwoFactorAuthenticationDto
): Promise<ReadGenerateTwoFactorAuthenticationDto> {
  return apiRequest<ReadGenerateTwoFactorAuthenticationDto>(
    "post",
    `/auth/generate-two-factor-authentication`,
    generateTwoFactorAuthenticationDto
  );
}

export async function enableTwoFactorAuthentication(
  enableToken: EnableTokenTwoFactorAuthenticationDto
): Promise<ReadEnableTwoFactorAuthenticationDto> {
  return apiRequest<ReadEnableTwoFactorAuthenticationDto>(
    "put",
    `/auth/enable-two-factor-authentication`,
    enableToken
  );
}

export async function verifyTwoFactorAuthentication(
  verifyToken: VerifyTokenTwoFactorAuthenticationDto
): Promise<ReadVerifyTokenTwoFactorAuthenticationDto> {
  return apiRequest<ReadVerifyTokenTwoFactorAuthenticationDto>(
    "put",
    `/auth/verify-two-factor-authentication`,
    verifyToken
  );
}
